import { useState } from "react";
import { Form } from "react-bootstrap";
import ApproverService from "../../services/approver.service";
import CardModal from "../../components/CardModal";

const TenorForm = ({ show, onHide, projectData }) => {
	const [projectTenor, setProjectTenor] = useState("");
	
	const handleSubmit = (e) => {
		e.preventDefault();
		const _projectTenor = {tenor: projectTenor};
		ApproverService.updateProjectTenor(projectData._id, _projectTenor);
		window.location.reload();
	};
	
	const handleSelectTenor = (e) => setProjectTenor(e.target.value);

	return (
		<CardModal
			heading={"Review Project Tenor"}
			show={show}
			onHide={onHide}
			submit={handleSubmit}
		>
			<div className="card" style={{ margin: "auto" }}>
				<div className="card-inside card__radio">
					<div className="card-info card__radio-btn">
						<Form.Check.Input
							onChange={handleSelectTenor}
							checked={projectTenor === "2"}
							value="2"
							type="radio"
						/>
						<Form.Check.Label>2 Years</Form.Check.Label>
					</div>
					<div className="card-info card__radio-btn">
						<Form.Check.Input
							onChange={handleSelectTenor}
							checked={projectTenor === "4"}
							value="4"
							type="radio"
						/>
						<Form.Check.Label>4 Years</Form.Check.Label>
					</div>
					<div className="card-info card__radio-btn">
						<Form.Check.Input
							onChange={handleSelectTenor}
							checked={projectTenor === "6"}
							value="6"
							type="radio"
						/>
						<Form.Check.Label>6 Years</Form.Check.Label>
					</div>
					<div className="card-info card__radio-btn">
						<Form.Check.Input
							onChange={handleSelectTenor}
							checked={projectTenor === "8"}
							value="8"
							type="radio"
						/>
						<Form.Check.Label>8 Years</Form.Check.Label>
					</div>
					<div className="card-info card__radio-btn">
						<Form.Check.Input
							onChange={handleSelectTenor}
							checked={projectTenor === "10"}
							value="10"
							type="radio"
						/>
						<Form.Check.Label>10 Years</Form.Check.Label>
					</div>
					<div className="card-info card__radio-btn">
						<Form.Check.Input
							onChange={handleSelectTenor}
							checked={projectTenor === "12"}
							value="12"
							type="radio"
						/>
						<Form.Check.Label>12 Years</Form.Check.Label>
					</div>
				</div>
				<span className="card__radio-span">
					Click circle to select project tenor
				</span>
			</div>
		</CardModal>
	);
};

export default TenorForm;
